import { createAction, props } from '@ngrx/store';
import { ShoppingCartPhysicalDeliveryFormData } from '@rd/form-builder/types/shopping-cart-delivery-form-data.type';
import { HttpError } from '@rd/types';
import { Order } from '@rd/types/order.type';

export enum DeliveryDetailsActionTypes {
  UPDATE_DELIVERY_DETAILS = '[ShoppingCart] Update DeliveryDetails',
  UPDATE_DELIVERY_DETAILS_SUCCESS = '[ShoppingCart] Update DeliveryDetails Success',
  UPDATE_DELIVERY_DETAILS_FAIL = '[ShoppingCart] UpdateDeliveryDetails Fail',
}

export const UpdateDeliveryDetails = createAction(
  DeliveryDetailsActionTypes.UPDATE_DELIVERY_DETAILS,
  props<{ deliveryDetails: Partial<ShoppingCartPhysicalDeliveryFormData> }>(),
);

// Updating delivery details returns an updated Order, so we return an Order.
// It is possible that we might change `UpdateDeliveryDetails` to `UpdateOrder` in the future.
export const UpdateDeliveryDetailsSuccess = createAction(
  DeliveryDetailsActionTypes.UPDATE_DELIVERY_DETAILS_SUCCESS,
  props<{ order: Order }>(),
);

export const UpdateDeliveryDetailsFail = createAction(
  DeliveryDetailsActionTypes.UPDATE_DELIVERY_DETAILS_FAIL,
  props<HttpError>(),
);
